import { useEffect, useState } from "react";
import CustomModel from "../../components/custom-model/CustomModel";
import { addEditorValidationSchema } from "../../utils/formik/validationSchema";
import { addPrincipalInvestigatorValues } from "../../utils/formik/initialValues";
import EditorApi from "../../services/editorManagementService";
import { notify } from "../../bmr/utils/methods/notification";

const normalizeCountryCode = (value) => {
  const code = String(value || "91").replace(/\D/g, "");
  return code || "91";
};

function EditorManagementEdit({
  openModal,
  setOpenModal,
  id = "",
  piList,
  editorDetailedData,
  phaseList = [],
  getSubAdminDetails,
  setPiId
}) {
  const [initialValues, setInitialValues] = useState(
    addPrincipalInvestigatorValues
  );

  const[submitLoading,setSubmitLoading] = useState(false);
  const [modelData, setModelData] = useState({
    title: "Add Editor",
    editTitle: "Edit Editor",
    children: [
      {
        type: "input",
        name: "name",
        label: "Name",
        placeholder: "Enter Name",
        IsRequired: true,
      },
      {
        type: "input",
        name: "email",
        label: "Email",
        placeholder: "Enter Email",
        IsRequired: true,
      },
      {
        type: "phone",
        name: "phoneNumber",
        label: "Phone Number",
        placeholder: "Enter Phone Number",
        countryCodeName: "countryCode",
        defaultCountry: "in",
        IsRequired: true,
      },
      {
        type: "dropdown",
        name: "principalInvestigator",
        label: "Principal Investigator/HCP",
        placeholder: "Select Principal Investigator/HCP",
        data: [],
        IsRequired: true,
      },
      {
        type: "multidropdown",
        name: "trial",
        label: "Phase",
        placeholder: "Select Phase",
        data: [],
        IsRequired: true,
      },
    ],
  });

  useEffect(() => {
    setInitialValues({
      name: editorDetailedData?.name,
      email: editorDetailedData?.email,
      countryCode: normalizeCountryCode(editorDetailedData?.country_code),
      phoneNumber: editorDetailedData?.phone?.toString(),
      trial: editorDetailedData?.phaseDetails?.map(item => item.id),
      principalInvestigator: editorDetailedData?.investigator_details?.id,
    });
  }, [editorDetailedData]);

  useEffect(() => {
    const newChildren = [
      {
        type: "input",
        name: "name",
        label: "Name",
        placeholder: "Enter Name",
        IsRequired: true,
      },
      {
        type: "phone",
        name: "phoneNumber",
        label: "Phone Number",
        placeholder: "Enter Phone Number",
        countryCodeName: "countryCode",
        defaultCountry: "in",
        IsRequired: true,
      },
      {
        type: "dropdown",
        name: "principalInvestigator",
        label: "Principal Investigator/HCP",
        placeholder: "Select Principal Investigator/HCP",
        data: piList,
        IsRequired: true,
      },
      {
        type: "multidropdown",
        name: "trial",
        label: "Phase",
        placeholder: "Select Phase",
        data: phaseList,
        IsRequired: true,
      },
    ];

    newChildren.push({
      type: "input",
      name: "email",
      label: "Email",
      placeholder: "Enter Email",
      IsRequired: true,
      disabled: true,
    });

    setModelData((prevModelData) => ({
      ...prevModelData,
      children: newChildren,
    }));
  }, [id, piList, phaseList]);

  const handleEditModelValues = async (values) => {
    setSubmitLoading(true);
    const dataIds = editorDetailedData?.phaseDetails?.map(item => item.id);
    // // Filter out the IDs that are present in values?.trial
    const missingIds = dataIds?.filter(id => !values?.trial.includes(id));
    const isInvestigator = editorDetailedData?.investigator_details?.id !== values?.principalInvestigator ? editorDetailedData?.investigator_details?.id : 0
    try {
      const res = await EditorApi.editEditor(
        {
          name: values?.name,
          email: values?.email,
          country_code: normalizeCountryCode(values?.countryCode),
          phone: values?.phoneNumber?.toString(),
          phase_ids: values?.trial,
          role_id: editorDetailedData?.role_id || "",
          investigator_id: values?.principalInvestigator,
          removedPhaseIds: missingIds,
          removedInvestigatorId: isInvestigator
        },
        id
      );

      if (res.status === 200) {
         notify.success(res?.message)
        setOpenModal(false);
        setSubmitLoading(false);
        getSubAdminDetails();
      }
    } catch (error) {
      notify.error(error)
       setSubmitLoading(false);
    }
  };

  const handleChange = (e) => {
    setPiId(e)
  }


  return (
    <>
      <CustomModel
        rowId={id}
        modalInitialValues={initialValues}
        initialValuesValidationSchema={addEditorValidationSchema}
        open={openModal}
        setOpen={setOpenModal}
        setModelData={setModelData}
        modelData={modelData}
        handleModelValues={handleEditModelValues}
        isLoadingBtn={submitLoading}
        onChange={handleChange}
      />
    </>
  );
}

export default EditorManagementEdit;
